export default "__VITE_ASSET__BUJ2DsFh__"